import React from "react";
import { useTranslation } from "react-i18next";
import "./SCUINoRecordComponent.scss";
import billingInfoImage from "../../../assets/icons/svg/pageIcons/billingInfo.svg";
import { Grid } from "@mui/material";

export const SCUINoRecordComponent = (props: any) => {
  const { t } = useTranslation();
  const getStyles = () => {
    const baseStyles: any = {
      textAlign: "center",
      marginTop: "2rem",
      color: "#C4C4C4",
      fontWeight: "bold",
    };

    if (props.fontSize) {
      baseStyles.fontSize = props.fontSize;
    }

    return baseStyles;
  };
  return (
    <Grid
      size={{
        xl: 12,
        lg: 12,
        md: 12,
        xs: 12
      }}>
      <br />
      {props.img ? (
        <img
          src={props.img}
          style={{ height: props.height || "", width: props.width || "" }}
          className="centeredImg"
          alt=""
        ></img>
      ) : (
        <img src={billingInfoImage} className="centeredImg" alt=""></img>
      )}
      {props.text ? (
        <h3 style={getStyles()}>{t(props.text)}</h3>
      ) : (
        <p style={getStyles()}>{t("billingServiceLog.noRecordText")}</p>
      )}
    </Grid>
  );
};
